import React from "react";

const SectionTitle = ({ title, subtitle, className = "" }) => {
  return (
    <div className={className}>
      <h2 className="text-2xl font-semibold text-gray-800">{title}</h2>
      {subtitle && <p className="text-gray-600 mt-1">{subtitle}</p>}
    </div>
  );
};

export default SectionTitle;